// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var unsafeFromRight = function (dictShow) {
    return function (name) {
        return function (e) {
            return function __do() {
                if (e instanceof Data_Either.Left) {
                    return Partial_Unsafe.unsafeCrashWith("Error decoding " + (name + (": " + Data_Show.show(dictShow)(e.value0))))();
                };
                if (e instanceof Data_Either.Right) {
                    return e.value0;
                };
                throw new Error("Failed pattern match at Data.Either.Extra (line 57, column 3 - line 59, column 22): " + [ e.constructor.name ]);
            };
        };
    };
};
var fromRightWith_ = function (def) {
    return function (v) {
        if (v instanceof Data_Either.Left) {
            return def;
        };
        if (v instanceof Data_Either.Right) {
            return v.value0;
        };
        throw new Error("Failed pattern match at Data.Either.Extra (line 36, column 3 - line 38, column 17): " + [ v.constructor.name ]);
    };
};
var fromRightWith = function (f) {
    return function (v) {
        if (v instanceof Data_Either.Left) {
            return f(v.value0);
        };
        if (v instanceof Data_Either.Right) {
            return v.value0;
        };
        throw new Error("Failed pattern match at Data.Either.Extra (line 23, column 3 - line 25, column 17): " + [ v.constructor.name ]);
    };
};
var fromRightM = function (dictApplicative) {
    return function (f) {
        return function (v) {
            if (v instanceof Data_Either.Left) {
                return f(v.value0);
            };
            if (v instanceof Data_Either.Right) {
                return Control_Applicative.pure(dictApplicative)(v.value0);
            };
            throw new Error("Failed pattern match at Data.Either.Extra (line 49, column 3 - line 51, column 22): " + [ v.constructor.name ]);
        };
    };
};
export {
    fromRightWith,
    fromRightWith_,
    fromRightM,
    unsafeFromRight
};
//# sourceMappingURL=index.js.map
